// extracted by mini-css-extract-plugin
export default {"root":"main_root__Z43+g","header":"main_header__obV+t","notice":"main_notice__NYj9Y","noticeItem":"main_noticeItem__M+ofg","chat":"main_chat__GX+ln"};